import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { LoyaltyGetRewardCardType, RewardCard } from "types/Loyalty";
import ArrowIcon from "assets/icons/banger/arrow-right.svg?react";
import useTranslate from "../../../hooks/useTranslate";

import "./styles.sass";
import { ExpSettings } from "../../../types/ExpSettings";

type LoyaltyGetRewardCardPorps = {
  card: LoyaltyGetRewardCardType;
  exp?: ExpSettings;
};

export const LoyaltyGetRewardCard = ({
  card,
  exp,
}: LoyaltyGetRewardCardPorps) => {
  const { id, img, title, desc, type, buttonText, url } = card;
  const cost = exp?.cost || 0;
  const amount = exp?.amount || 0;
  const currency = exp?.currency || "";

  const t = useTranslate();
  const navigate = useNavigate();
  const isBonus = type === RewardCard.BONUS;

  const handleClick = () => {
    if (isBonus && url) {
      navigate(url);
    }
  };
  const buttonClass = classNames("LoyaltyGetRewardCard-content__btn", {
    bonus: isBonus,
  });

  const experienceBtn = `${amount} ${t("loyalty.reward.experience.btn")} ${cost} ${currency}`;

  return (
    <div className="LoyaltyGetRewardCard">
      <img src={img} alt="card" className="LoyaltyGetRewardCard__img" />
      <span className="LoyaltyGetRewardCard__number">{id}</span>
      <section className="LoyaltyGetRewardCard-content">
        <div className="LoyaltyGetRewardCard-content-block">
          <span className="LoyaltyGetRewardCard-content-block__title">
            {t(title)}
          </span>
          <span className="LoyaltyGetRewardCard-content-block__desc">
            {t(desc)}
          </span>
        </div>
        <button type="button" className={buttonClass} onClick={handleClick}>
          {isBonus ? (
            <>
              {t(buttonText)} <ArrowIcon />
            </>
          ) : (
            experienceBtn
          )}
        </button>
      </section>
    </div>
  );
};
